export const STATE_KEY = 'customerHistory'

export const SET_COMM_HISTORY_LOADING = 'SET_COMM_HISTORY_LOADING'
export const SET_COMM_HISTORY = 'SET_COMM_HISTORY'
export const APPEND_COMM_HISTORY = 'APPEND_COMM_HISTORY'
export const SET_COMM_HISTORY_ERROR = 'SET_COMM_HISTORY_ERROR'
export const CLEAR_COMM_HISTORY = 'CLEAR_COMM_HISTORY'

const initialState = {
  loading: false,
  hasLoaded: false,
  error: null,
  events: [],
  nextCursor: null,
}

// The Communication History band is lazy: it holds nothing until the dealer
// opens the expander, then fetches page 1; "load more" appends the next keyset
// page. Cleared on unmount and whenever the viewed customer changes.
//
// A failed FIRST page leaves hasLoaded false, so closing and reopening the band
// tries again — otherwise one bad response strands the customer's history until
// the dealer navigates away.
export default function customerHistoryReducers(state = initialState, action) {
  switch (action.type) {
    case SET_COMM_HISTORY_LOADING:
      return { ...state, loading: true, error: null }

    case SET_COMM_HISTORY:
      return {
        ...state,
        loading: false,
        hasLoaded: true,
        error: null,
        events: action.payload.events || [],
        nextCursor: action.payload.nextCursor || null,
      }

    case APPEND_COMM_HISTORY:
      return {
        ...state,
        loading: false,
        events: [...state.events, ...(action.payload.events || [])],
        nextCursor: action.payload.nextCursor || null,
      }

    case SET_COMM_HISTORY_ERROR:
      return { ...state, loading: false, error: action.payload }

    case CLEAR_COMM_HISTORY:
      return { ...initialState }

    default:
      return state
  }
}
